import type { SvgIconComponent } from "@mui/icons-material";
import CampaignIcon from "@mui/icons-material/Campaign";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import { ROUTES } from "~/constants/routing";

export enum EventTagEnum {
  ALL = "all",
  NEW = "new",
  ENDING_SOON = "ending_soon",
  TRENDING = "trending_market",
  BREAKING = "breaking_market",
}

export type EventTagValue = `${EventTagEnum}`;

export type EventTabParam =
  EventTagEnum.ALL | EventTagEnum.NEW | EventTagEnum.ENDING_SOON;

const eventTagValues = new Set<string>(Object.values(EventTagEnum));

export const isEventTagValue = (value: string): value is EventTagValue =>
  eventTagValues.has(value);

export const labelByEventTagEnum: Record<EventTagEnum, string> = {
  [EventTagEnum.ALL]: "All",
  [EventTagEnum.NEW]: "New",
  [EventTagEnum.ENDING_SOON]: "Ending Soon",
  [EventTagEnum.TRENDING]: "Trending",
  [EventTagEnum.BREAKING]: "Breaking",
};

export const colorByEventTagEnum: Record<EventTagEnum, string> = {
  [EventTagEnum.ALL]: "",
  [EventTagEnum.NEW]: "#047857",
  [EventTagEnum.ENDING_SOON]: "#1D4ED8",
  [EventTagEnum.TRENDING]: "#C2410C",
  [EventTagEnum.BREAKING]: "#B91C1C",
};

export const bgColorByEventTagEnum: Record<EventTagEnum, string> = {
  [EventTagEnum.ALL]: "",
  [EventTagEnum.NEW]: "#D1FAE5",
  [EventTagEnum.ENDING_SOON]: "#DBEAFE",
  [EventTagEnum.TRENDING]: "#FFFBF5",
  [EventTagEnum.BREAKING]: "#FEF2F2",
};

export const routeByEventTagEnum: Record<EventTagEnum, string> = {
  [EventTagEnum.ALL]: ROUTES.main.path,
  [EventTagEnum.NEW]: ROUTES.new.path,
  [EventTagEnum.ENDING_SOON]: ROUTES.endingSoon.path,
  [EventTagEnum.TRENDING]: ROUTES.trending.path,
  [EventTagEnum.BREAKING]: ROUTES.breaking.path,
};

export const glyphByEventTagEnum: Record<
  EventTagEnum,
  string | SvgIconComponent
> = {
  [EventTagEnum.ALL]: "",
  [EventTagEnum.NEW]: "🌟",
  [EventTagEnum.ENDING_SOON]: "⌛",
  [EventTagEnum.TRENDING]: TrendingUpIcon,
  [EventTagEnum.BREAKING]: CampaignIcon,
};

export const rowGlyphByEventTagEnum: Partial<
  Record<EventTagEnum, SvgIconComponent>
> = {
  [EventTagEnum.BREAKING]: CampaignOutlinedIcon,
};

export const rowColorByEventTagEnum: Partial<Record<EventTagEnum, string>> = {
  [EventTagEnum.BREAKING]: "#C62828",
  [EventTagEnum.TRENDING]: "#3F3F46",
};

export const rowBgColorByEventTagEnum: Partial<Record<EventTagEnum, string>> = {
  [EventTagEnum.BREAKING]: "#FDECEC",
  [EventTagEnum.TRENDING]: "#F4F4F5",
};

export const rowTooltipByEventTagEnum: Partial<Record<EventTagEnum, string>> = {
  [EventTagEnum.BREAKING]: "Breaking — moving fast in the last hour.",
  [EventTagEnum.TRENDING]: "Among the most-traded events right now.",
};
